import Cookies from "js-cookie";

import {
  AD_SOURCE_COOKIE_KEY,
  extractAdSourceFromDeepLink,
  extractLandingIdFromDeepLink,
  extractQuerySourceFromDeepLink,
  isAdSkipSource,
} from "./adSource";
import {
  setAdSourceInStore,
  setLandingIdInStore,
  setQuerySourceInStore,
} from "./adSourceStore";

const COOKIE_OPTIONS: Cookies.CookieAttributes = {
  expires: 365,
  path: "/",
  sameSite: "Lax",
};

function withSecureFlag(): Cookies.CookieAttributes {
  if (typeof window === "undefined") {
    return COOKIE_OPTIONS;
  }
  return {
    ...COOKIE_OPTIONS,
    secure: window.location.protocol === "https:",
  };
}

/** 读取本地 ad_source cookie；无则 null。 */
export function getAdSourceCookie(): string | null {
  if (typeof document === "undefined") {
    return null;
  }
  const raw = Cookies.get(AD_SOURCE_COOKIE_KEY)?.trim();
  return raw ? raw : null;
}

/**
 * 写入 ad_source cookie。
 * 调用方负责覆盖语义：后端 ownerInfo.ad_source 优先覆盖本地（见 useOnboardingEntryGate / fetchUserInfo）。
 */
export function setAdSourceCookie(value: string): void {
  if (typeof document === "undefined") {
    return;
  }
  const trimmed = value?.trim();
  if (!trimmed) {
    return;
  }
  Cookies.set(AD_SOURCE_COOKIE_KEY, trimmed.toUpperCase(), withSecureFlag());
}

/** 当前 cookie 的 ad_source 是否应跳过 onboarding 直落 Brief。 */
export function shouldAdSkipOnboarding(): boolean {
  return isAdSkipSource(getAdSourceCookie());
}

/** 从深链 payload 提取 ad_source + query_source + landing_id 并写入（ad_source→cookie+store，query_source/landing_id→仅 store）。 */
export function captureAdSourceFromDeepLink(
  data: Parameters<typeof extractAdSourceFromDeepLink>[0],
): string | null {
  const adSource = extractAdSourceFromDeepLink(data);
  if (adSource) {
    setAdSourceCookie(adSource);
    setAdSourceInStore(adSource);
  }
  // query_source：只存 store，不存 cookie
  const querySource = extractQuerySourceFromDeepLink(data);
  if (querySource) {
    setQuerySourceInStore(querySource);
  }
  // landing_id：只存内存 store（会话级），不写 cookie，不影响 ad_source 跳过 onboarding 判断
  const landingId = extractLandingIdFromDeepLink(data);
  if (landingId) {
    setLandingIdInStore(landingId);
  }
  return adSource;
}
